let filterHeaders = document.querySelectorAll('.filter-group-header')

if(filterHeaders.length) {
    for(let header of filterHeaders) {
        header.addEventListener('click', () => {
            let wrapper = header.parentElement

            wrapper.classList.toggle('hide')
        })
    }
}

/////

let applyFiltersBtns = document.querySelectorAll('.apply-filters')

if(applyFiltersBtns.length) {
    for(let btn of applyFiltersBtns) {
        btn.addEventListener('click', () => {
            let filters = getFilters()
    
            applyFilters(filters)
        })
    }
}

function applyFilters(filters = '') {
    let url = new URL(window.location.href)

    if(filters && Object.keys(filters).length) {
        let request = []

        for(let key in filters) {
            let value = filters[key]

            if(typeof value == 'array') {
                value = value.join(',')
            }

            request.push(key + ':' + value)
        }

        request = request.join('.')

        url.searchParams.set('filters', request)
    } else {
        url.searchParams.delete('filters')
    }

    window.location.href = url.href
}

/////

let clearFilters = document.querySelectorAll('.clear-filters')

if(clearFilters.length) {
    for(let btn of clearFilters) {
        btn.addEventListener('click', () => {
            applyFilters()
        })
    }
}

////

let removeFilters = document.querySelectorAll('.remove-applied-filter')

if(removeFilters.length) {
    for(let btn of removeFilters) {
        btn.addEventListener('click', () => {
            let slug = btn.dataset.filter
            let value = btn.dataset.value
            let filters = getFilters()

            if(filters[slug] && value) {
                let index = filters[slug].indexOf(value)

                if(index != -1) {
                    filters[slug].splice(index, 1)
                }

                if(!filters[slug].length) {
                    delete filters[slug]
                }
            } else {
                delete filters[slug]
            }

            applyFilters(filters)
        })
    }
}

////

function getFilters() {
    let {priceSlider} = window
    let filters = {}
    let applied = document.querySelectorAll('.filter-checkbox:checked')

    if(applied.length) {
        for(let item of applied) {
            let slug = item.dataset.filter
            let value = item.value

            if(!filters[slug]) {
                filters[slug] = [value]
            } else {
                filters[slug].push(value)
            }
        }
    }

    if(priceSlider) {
        let values = priceSlider.get()
        let min = Number(values[0])
        let max = Number(values[1])
        let {range} = priceSlider.options

        if(min != range.min) {
            filters.min = min
        }

        if(max != range.max) {
            filters.max = max
        }
    }

    return filters
}

/////

let sortBtns = document.querySelectorAll('.archive-sorting .item')

if(sortBtns.length) {
    for(let btn of sortBtns) {
        btn.addEventListener('click', () => {
            let key = btn.dataset.sort
            let sort

            if(btn.classList.contains('asc')) {
                sort = {
                    field: key,
                    sort: 'desc',
                }
            } else {
                sort = {
                    field: key,
                    sort: 'asc',
                }
            }

            applySort(sort)
        })
    }
}

function applySort(sort) {
    let url = new URL(window.location.href)

    if(sort && Object.keys(sort).length) {
        let request = Object.values(sort).join(':')

        url.searchParams.set('sort', request)
    } else {
        url.searchParams.delete('sort')
    }

    window.location.href = url.href
}

function getSort() {
    let url = new URL(window.location.href)
    let sort = url.searchParams.get('sort')

    if(sort) {
        sort = sort.split(':')
        sort = {
            field: sort[0],
            sort: sort[1],
        }
    }

    return sort
}

/////

let allowOut = false
let floatingApply = document.querySelector('.floating-apply')

if(floatingApply) {
    clickOut(floatingApply, () => {
        if(allowOut) {
            floatingApply.hide()
            allowOut = false
        }
    })
}

function attachFloationgButton(element) {
    let offset = window.pageYOffset
    let rect = element.getBoundingClientRect()
    let top = offset + rect.top + (rect.height / 2)
    let left = rect.left + rect.width

    if(window.innerWidth < 768) {
        top = rect.top + rect.height
    }

    floatingApply.style.top = top + 'px'
    floatingApply.style.left = left + 'px'
    floatingApply.style.display = 'block'
    
    setTimeout(() => {
        allowOut = true
    }, 20)
}

let filterCheckboxes = document.querySelectorAll('.filter-checkbox')

if(filterCheckboxes.length) {
    for(let input of filterCheckboxes) {
        input.addEventListener('change', () => {
            attachFloationgButton(input.closest('.filter-group-checkbox-item'))
        })
    }
}